import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { FaTimes, FaRocket } from "react-icons/fa";
import confetti from "canvas-confetti";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ModalComponent.css";

const ModalComponent = ({
  show,
  handleClose,
  imageUrl,
  redirectUrl,
  buttonText,
  linkRedirector
}) => {
  const confettiCanvasRef = useRef(null);
 const MOBILE_VIEW_WIDTH = 500;
  useEffect(() => {
    if (show && confettiCanvasRef.current) {
       const isMobile = window.innerWidth < MOBILE_VIEW_WIDTH;
      const myConfetti = confetti.create(confettiCanvasRef.current, {
        resize: true,
        useWorker: true
      });
      
      const duration = 1 * 1000; 
      const end = Date.now() + duration;

      const fireConfetti = () => {
        myConfetti({
          particleCount: isMobile ? 40 : 90,
          spread: 100, 
          origin: { x: 0, y: 0.5 },
          colors: ['#1e90ff', '#ff69b4', '#ffff00', '#32cd32'], 
          angle: 60,
          startVelocity: isMobile ? 17 : 40, 
          gravity: 0.8,
          decay: 0.92,
          scalar: 1,
           ticks: isMobile ? 130 : 200
        });

        myConfetti({
        particleCount: isMobile ? 40 : 90,
          spread: 100,
          origin: { x: 0, y: 0.8 },
          colors: ['#1e90ff', '#ff69b4', '#ffff00', '#32cd32'],
          angle: 45,
          startVelocity: isMobile ? 17 : 40, 
          gravity: 0.8,
          decay: 0.92,
          scalar: 0.8,
         ticks: isMobile ? 130 : 200
        });
        myConfetti({
          particleCount: isMobile ? 40 : 90,
          spread: 100,
          origin: { x: 1, y: 0.5 },
          colors: ['#1e90ff', '#ff69b4', '#ffff00', '#32cd32'],
          angle: 120,
         startVelocity: isMobile ? 17 : 40, 
          gravity: 0.8,
          decay: 0.92,
          scalar: 0.8,
          ticks: isMobile ? 130 : 200
        });
        myConfetti({
          particleCount: isMobile ? 40 : 90,
          spread: 100,
          origin: { x: 1, y: 0.8 },
          colors: ['#1e90ff', '#ff69b4', '#ffff00', '#32cd32'],
          angle: 135,
          startVelocity: isMobile ? 17 : 40, 
          gravity: 0.8,
          decay: 0.92,
          scalar: 0.8,
         ticks: isMobile ? 130 : 200
        });
      };
      const interval = setInterval(() => {
        if (Date.now() > end) {
          clearInterval(interval);
          return;
        }
        fireConfetti();
      }, 450);
      return () => clearInterval(interval);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
       backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal"
      aria-labelledby="appointment-modal"
      size="xl"
    >
      <canvas ref={confettiCanvasRef} className="confetti-canvas"></canvas>
      

      <div className="modal-body-content">
      <button type="button" className="close-button" onClick={handleClose}>
        <FaTimes />
      </button>
        <a href={linkRedirector} target="_blank" rel="noopener noreferrer">
        <img src={imageUrl} alt="Banner" className="eventWelcomeBanner" />
        </a>

        <div className="action-container">
          <div className="rocket-icon-outside">
            <FaRocket />
          </div>
          <a
            href={redirectUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="book-button"
          >
            {buttonText}
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default ModalComponent;